<template>
  <div class="auth">
    <div class="auth-controls">
      <div class="wrapper pb-0">
      </div>
    </div>

    <div class="wrapper">
      <div class="auth__in">
        <div class="forgot">
          <div class="auth-heading">
            <h2>{{ trans.text.reset.recover }}</h2>
          </div>

          <div class="auth-form">
            <div class="inp-group">
              <label for="signup-mail">{{ trans.text.reset.email }}</label>
              <input class="inp-style inp-fw" id="signup-mail" disabled name="#" type="email" v-model="email">
            </div>

            <div class="inp-group">
              <label for="signup-pwd" v-if="!showPasswordError">{{ trans.text.reset.password }}</label>
              <span class="inp-error__text_" v-if="showPasswordError">{{ getPasswordErrorText }}</span>
              <input class="inp-style inp-fw" id="signup-pwd" name="#" type="password" v-model="password">
            </div>

            <div class="inp-group">
              <label for="signup-pwd2"
                     v-if="!showPasswordConfirmationError">{{ trans.text.reset.retypePassword }}</label>
              <span class="inp-error__text_" v-if="showPasswordConfirmationError">
                                {{ trans.text.reset.notSame }}
                            </span>
              <input class="inp-style inp-fw" id="signup-pwd2" name="#" type="password"
                     v-model="password_confirmation">
            </div>
            <span class="inp-error__text1" v-if="Error">{{ Error }}</span>
            <span class="inp-error__text2" v-if="Success">{{ Success }}</span>

            <button :class="registerDisabled ? 'disabled' : ''" :disabled="registerDisabled"
                    @click="submit" class="btn btn-green btn-submit">
              {{ trans.text.reset.resetBtn }}
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  props: ['reset_token', 'lang', 'trans'],
  data() {
    return {
      // email: localStorage.getItem('email') ? localStorage.getItem('email') : '',
      email: '',
      password: '',
      password_confirmation: '',
      Error: '',
      Success: '',
      token: this.reset_token,
      wrongFormatPassword: false,
      wrongPasswordConfirmation: false
    }
  },
  computed: {
    ...mapGetters(['getEmailError', 'getNameError', 'getPasswordError']),
    showPasswordError() {
      return !!this.getPasswordError || this.wrongFormatPassword;
    },
    showPasswordConfirmationError() {
      return this.wrongPasswordConfirmation;
    },
    getPasswordErrorText() {
      if (this.getPasswordError) {
        return this.getPasswordError;
      }
      return this.trans.text.reset.passwordValidation;
    },
    registerDisabled() {
      return this.email.length === 0
        || this.password.length === 0
        || this.password_confirmation.length === 0
        || this.wrongFormatPassword
        || this.wrongPasswordConfirmation
    }
  },
  mounted() {
    this.find();
  },
  methods: {
    find() {
      let _this = this
      axios
        .get(this.$path + '/password/find/' + _this.token, {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        .then(response => {
          _this.email = response.data.email
        })
        .catch(err => {
          _this.Error = err.response.data.errors.reset[0]
          _this.Success = '';
          setTimeout(() => {
            _this.wrongFormatPassword = null;
            _this.wrongPasswordConfirmation = null;
            _this.Success = null;
            _this.Error = null;
          }, 5000);
        })
    },
    submit() {
      let _this = this
      axios
        .post(this.$path + '/password/reset', {
          headers: {
            'Content-Type': 'application/json'
          },
          'email': this.email,
          'password': this.password,
          'password_confirmation': this.password_confirmation,
          'token': this.token,
        })
        .then(response => {
          _this.Success = response.data.message
          _this.Error = ''
          localStorage.removeItem('email');

          setTimeout(function () {
            location.href = `/${_this.lang}/login`
          }, 3000);

          setTimeout(() => {
            _this.wrongFormatPassword = null;
            _this.wrongPasswordConfirmation = null;
            _this.Success = null;
            _this.Error = null;
          }, 5000);

        })
        .catch(err => {
          _this.Error = err.response.data.errors.reset[0]
          _this.Success = ''

          setTimeout(() => {
            _this.wrongFormatPassword = null;
            _this.wrongPasswordConfirmation = null;
            _this.Success = null;
            _this.Error = null;
          }, 5000);
        })
    },
  },
  watch: {
    reset_token(val) {
      if (val) {
        this.token = this.reset_token
      }
    },
    password: {
      handler: function (password) {
        this.$store.commit('updatePasswordError', '');
        if (password.length === 0) {
          this.wrongFormatPassword = false;
        } else {
          this.wrongFormatPassword = password.trim().length < 8;
        }
      }
    },
    password_confirmation: {
      handler: function (password) {
        if (password.length === 0) {
          this.wrongPasswordConfirmation = false;
        } else {
          this.wrongPasswordConfirmation = password !== this.password;
        }
      }
    },
  }
}
</script>
<style scoped>
.inp-error__text_ {
  font-size: 14px;
  color: #E41B1B;
  display: block;
  margin: 0 0 .5rem;
  line-height: 100%;
}

.btn-submit.disabled {
  /*background: #c9c9c9;*/
  background: #efefef;
  color: rgba(0, 0, 0, .5);
  cursor: default;
}

.inp-error__text1 {
  font-size: 14px;
  color: #E41B1B;
  display: block;
  margin: 0 0 .5rem;
  line-height: 100%;
}

.inp-error__text2 {
  font-size: 14px;
  color: #000;
  display: block;
  margin: 0 0 .5rem;
  line-height: 100%;
}
</style>
